import { ReturnTypeEnum } from "./return-type-enum";

export const EXCHANGE_ORDER_PREFIX_TYPES = [
  ...Object.values(ReturnTypeEnum),
  "managed_claim",
] as const;
export type ExchangeOrderPrefixTypes =
  (typeof EXCHANGE_ORDER_PREFIX_TYPES)[number];
export const ExchangeOrderPrefixTypes = EXCHANGE_ORDER_PREFIX_TYPES;

export interface ExchangeOrderNameSettings {
  suffix: string | null;
  shouldStripHash: boolean;
  orderName: {
    prefix: string;
    suffix: string;
    orderNamesByReturnType: {
      prefix: string;
      suffix: string;
      returnType: ExchangeOrderPrefixTypes;
    }[];
    useShopifyGeneratedName: boolean;
    duplicateOrderNumberFormat?: string;
  };
}
